export const GET_NEWS_CALL_LIMIT = 5;
export const NEWS_REQUEST_CACHE_KEY = 'news:';
export const LATEST_NEWS_REQUEST_CACHE_KEY = 'latest';
